<script setup lang="ts"></script>

<template>
  <h1
    class="font-pragmatica-ext text-4xl font-bold sm:text-[calc(3.25rem+.5vw)] lg:text-7xl 2xl:text-8xl"
  >
    <slot />
  </h1>
</template>
